<!-- clonado de components/V2/ResourceScroller.MovieBox pero no adaptado totalmente para pictures. damn deadline-->
<template>
    <article
            :class="{placeholder: placeholder}"
            class="picture"
    >
        <template v-if="model && model.webstar && !picture.available">
          <div
              class="img locked"
              :style="cssVars"
          >
            <router-link
                class="lock"
                :to="link"
            >
              <img :src="getImageBackgroundUrl" :alt="picture.name">
            </router-link>
            <span v-if="picture.is_hd" class="hd" >HD</span>
            <span v-if="picture.length" class="length">{{pictureLengthFormatted}}</span>
            <BadgePostPremium :post="picture"/>
          </div>

          <div class="text">
            <h4 class="name">{{picture.name}}</h4>
            <p class="description">{{picture.description}}</p>
          </div>
        </template>
        <template v-else>
            <div class="img"></div>
            <div class="text">
                <h4 class="name"></h4>
                <p class="description"></p>
            </div>
        </template>
    </article>
</template>
<script>
import BadgePostPremium from "./BadgePostPremium";

export default {
  components: {BadgePostPremium},
  props: {
        picture: {
            type: Object,
            required: false,
            validate(value){
                return value !== undefined || this.placeholder;
            }
        },
        placeholder: {
            type: Boolean,
            required: false,
            default: false
        },
        model: {
            type: Object,
            required: false,
            default: null
        },
      imgStyle: {
        type: Object,
        required: false,
        default: null
      },
      getImageBackgroundUrl: {
        type: String,
        required: false,
        default: null
      },
      cssVars: {
        type: Object,
        required: false,
        default: null
      },
      link: {
        type: Object,
        required: false,
        default: null
      }
    },
    data(){
        return {}
    },
    watch: {},
    computed: {
        pictureLengthFormatted(){
            if(this.picture.length === null){
                return null;
            }

            let videoDuration = (new Date(this.picture.length * 1000)).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0];

            if (videoDuration.startsWith('00:')){
                return videoDuration.substr(3, videoDuration.length);
            }else{
                return videoDuration;
            }

        },
    }
}
</script>
<style scoped lang="scss">
@import '../../../styles/variables';

.picture{
    flex-grow: 0;
    flex-basis: 0;
    //padding-left: 5px;
    //padding-right: 5px;
    transition: width .5s ease;
    max-width: calc(100vw - 20px);
    margin-bottom: 40px;
    width: 100%;
    
    .img{
        //background-color: $pallete_secondary_color;
        background-color: #000000;
        position: relative;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        margin-bottom: .5em;
        //height: 300px;
        transition: height .5s ease;
        
        img{
            width: 100%;
            visibility: hidden;
        }

        span.hd{
            position: absolute;
            left: 5px;
            top: 5px;
            padding: 3px;
            font-weight: bold;
            border-radius: 2px;
            background-color: #000000;
            color: #ffffff;
        }

        span.length{
            position: absolute;
            right: 5px;
            bottom: 5px;
            padding: 3px;
            border-radius: 2px;
            font-size: 13px;
            background-color: #000000;
            color: #ffffff;
        }

        .preview-wrapper{
            opacity: 0;
            transition:opacity .30s linear;

            &.active{
                opacity: 1;
            }
        }

        .preview-wrapper.active{

            .preview{
                background-color: #000000;
                position: absolute;
                overflow: hidden;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;

                video{
                    /*object-fit: cover;*/
                    overflow:hidden;
                    min-width: 100%;
                    min-height: 100%;
                }
            }

            .preview-unavailable{
                position: absolute;
                top:0;
                left: 0;
                height: 100%;
                width: 100%;
                background-color: rgba(0,0,0,.25);
            }
        }
    }

    .text{
        text-align: left;
        .name{
            //text-transform: capitalize;
            margin: 0 0 10px 0;
        }
        .description{
            margin: 0;
            color: grey;
            //text-transform: capitalize;
        }
    }

    &.placeholder{
        .img{
            background-color: rgba(128,128,128,.25);
        }

        .text{

            .description{
                background-color: rgba(128,128,128,.25);
                height: 1em;
            }

            .name{
                background-color: rgba(128,128,128,.25);
                height: 1em;
            }
        }
    }

    .locked{
        z-index: 1;
    
        &:after{
            content: "";
            background: var(--background);
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            opacity: 0.4;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            position: absolute;
            z-index: -1;
        }
    
        img{
            width: 100%;
            visibility: hidden;
            max-height: 95vh;
        }
    
        .lock{
            display: block;
            width: 100%;
            height: 100%;
            background-image: url('/img/lock.png');
            background-size: 100px;
            background-repeat: no-repeat;
            background-position: center;
        }
    }
}
</style>